module.exports = "/fonts/tarra-picturemark-l-16a81128ea0ec73912aa9d927ab82ea2.svg";